import { UserSettings } from 'src/modules/common/types/UserSettings';
import { createTrigger } from 'src/utils/createTrigger';

export const UPDATE_USER_SETTINGS = createTrigger<UserSettings>('REPORT_SHOW_LOGO');
